// import external dependencies
import 'jquery';
import 'owl.carousel2';
// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import templateDefault from './routes/template-default';
import templateFlexiDefault from './routes/template-flexi-default';
import templateNewsListing from './routes/template-news-listing';
import templateJobListing from './routes/template-jobs-listing';
import templateEventsListing from './routes/template-events-listing';
import templateCylchSearchListing from './routes/template-cylch-search-listing';
import templateJobApplication from './routes/template-job-application';
import templateCorporateMembership from './routes/template-corporate-membership';
import templateAnnualMembership from './routes/template-annual-membership';
import templateContact from './routes/template-contact';
import templateHome from './routes/template-home';
import postTypeArchive from './routes/post-type-archive';
import singleProduct from './routes/single-product';
import singleCylchs from './routes/single-cylchs';
import singleJobs from './routes/single-jobs';
import single from './routes/single';
/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  templateDefault,
  templateFlexiDefault,
  templateNewsListing,
  templateJobListing,
  templateEventsListing,
  templateCylchSearchListing,
  templateJobApplication,
  templateCorporateMembership,
  templateAnnualMembership,
  templateContact,
  templateHome,
  // Shop listing page
  postTypeArchive,
  singleProduct,
  singleCylchs,
  singleJobs,
  single,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js